import { IRGBColor } from './color.types';
import { normalizeHex } from './normalizeHex';

export function hexToRgb(hex: string): IRGBColor {
  const value = normalizeHex(hex);

  return {
    r: parseInt(value.slice(0, 2), 16),
    g: parseInt(value.slice(2, 4), 16),
    b: parseInt(value.slice(4, 6), 16),
  };
}
